<div class="flex flex-col gap-(--gap-relaxed) w-full">
  <div class="font-medium">{{ 'common.labels.choice' | transloco }}</div>
  <div class="flex flex-col gap-(--gap-relaxed) max-h-[50vh] overflow-y-auto p-(--space-1) scrollbar-thin">
    @for (element of elements; track element; let i = $index) {
      <div class="flex flex-col" [ngClass]="{ 'gap-0': hasAnyError(element, i), 'gap-(--gap-normal)': !hasAnyError(element, i) }">
        <div class="flex flex-row items-center justify-between gap-(--gap-tight)">
          <label [for]="'choice_' + i">{{ 'common.labels.choice' | transloco }} {{ i + 1 }}</label>
        </div>
        <div class="flex flex-row gap-(--gap-normal) items-start">
          <div class="w-full">
            <ces-text-field
              [config]="fieldConfig('name')"
              [label]="''"
              [id]="'choice_' + i"
              [(ngModel)]="element.name"
              [required]="i === 0"
              (valueChange)="onNameChange($event, element, i)" />
            @if (isDuplicate(element, i)) {
              <div class="text-red-500 text-xs mt-(--space-1)">{{
                'entities.choiceList.errors.duplicateElementName' | transloco
              }}</div>
            }
          </div>
          @if (elements.length > 1 && canDeleteElement(element)) {
            <ces-delete-button (onClick)="removeElement(i)" />
          }
        </div>
      </div>
    }
  </div>

  <div>
    <ces-button-secondary
      [label]="choiceListElementDefinition.messages.buttons.add() | transloco"
      icon="add"
      size="small"
      (onClick)="addElement()" />
  </div>
</div>
